export const formFields = [
  {
    section: "General Information",
    name: "opcScheduleName",
    label: "Schedule",
    fieldLabel: "OPC Schedule Name",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [1, 1],
  },
  {
    section: "General Information",
    name: "opcDescription",
    label: "Description",
    fieldLabel: "OPC Description",
    type: "text",
    options: { maxLength: { value: 40, message: "MAXLENGTH_40" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [2, 1],
  },
  {
    section: "General Information",
    name: "opcBasis",
    label: "Basis",
    fieldLabel: "OPC Basis",
    type: "text",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [3, 1],
  },
  {
    section: "General Information",
    name: "opcStepCount",
    label: "Steps",
    fieldLabel: "OPC Step Count",
    type: "number",
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99, message: "MAX_99" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [4, 1],
  },
  {
    section: "General Information",
    name: "opdStepNumber",
    label: "Step Number",
    fieldLabel: "OPD Step Number",
    type: "number",
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99, message: "MAX_99" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [5, 1],
  },
  {
    section: "General Information",
    name: "pbdBenDedFlagSequence",
    label: "Substep Number",
    fieldLabel: "PBD Ben/Ded Flag Sequence",
    type: "number",
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999, message: "MAX_999" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [6, 1],
  },
  {
    section: "General Information",
    name: "opsApplyPlanOop",
    label: "Apply Plan OOP",
    fieldLabel: "/ Yes/No",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [7, 1],
  },
  {
    section: "General Information",
    name: "opsBasis",
    label: "Basis Override",
    fieldLabel: "OPC Basis",
    type: "dropdown",
    dropdownCondition: "Basic override values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [8, 1],
  },
  {
    section: "General Information",
    name: "opsAccumCodeList",
    label: "Accumulation Code List",
    fieldLabel: "OPS Accum Code List",
    type: "lookup",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    externalProgram: { default: "RCAL1005" },
    params: {
      lookupType: "local",
      viewType: "local",
      fieldMapping: {
        default: [
          {
            source: "opsAccumCodeList",
            target: "al1AccumulationCodeLst",
            legacy:"al1AccumulationCodeLst",
          },
          { source: "al1AccumCodeListDescr", target: "al1AccumCodeListDescr",legacy:"al1AccumCodeListDescr" },
        ],
      },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [9, 1],
  },
  {
    section: "General Information",
    name: "al1AccumCodeListDescr",
    label: "",
    fieldLabel: "",
    type: "text",
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [9, 2],
  },
  {
    section: "OOP Max (Header)",
    name: "opsMbrOopMaxAmount",
    label: "Individual",
    fieldLabel: "OPS Mbr OOP Max Amount",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [10, 1],
  },
  {
    section: "OOP Max (Header)",
    name: "opsFamOopMaxAmount",
    label: "Family",
    fieldLabel: "OPS Fam OOP Max Amount",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [11, 1],
  },

  {
    section: "Table format with below columns",
    format: "columnHeader",
    label: "Exclude Tier",
    type: "label",
    position: [16, 1],
  },
  {
    section: "Table format with below columns",
    format: "columnHeader",
    label: "Tier Qualifier",
    type: "label",
    position: [16, 2],
  },

  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTier1",
    label: "",
    fieldLabel: "OPS Exclude Tier 1",
    type: "text",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 1],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTierQual1",
    label: "",
    fieldLabel: "PBD Exclude Tier Qual 01",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 2],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTier2",
    label: "",
    fieldLabel: "OPS Exclude Tier 2",
    type: "text",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [18, 1],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTierQual2",
    label: "",
    fieldLabel: "PBD Exclude Tier Qual 01",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [18, 2],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTier3",
    label: "",
    fieldLabel: "OPS Exclude Tier 3",
    type: "text",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [19, 1],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTierQual3",
    label: "",
    fieldLabel: "PBD Exclude Tier Qual 01",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [19, 2],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTier4",
    label: "",
    fieldLabel: "OPS Exclude Tier 4",
    type: "text",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [20, 1],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTierQual4",
    label: "",
    fieldLabel: "PBD Exclude Tier Qual 01",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [20, 2],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTier5",
    label: "",
    fieldLabel: "OPS Exclude Tier 5",
    type: "text",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [21, 1],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTierQual5",
    label: "",
    fieldLabel: "PBD Exclude Tier Qual 01",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [21, 2],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTier6",
    label: "",
    fieldLabel: "OPS Exclude Tier 6",
    type: "text",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [22, 1],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTierQual6",
    label: "",
    fieldLabel: "PBD Exclude Tier Qual 01",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [22, 2],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTier7",
    label: "",
    fieldLabel: "OPS Exclude Tier 7",
    type: "text",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [23, 1],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTierQual7",
    label: "",
    fieldLabel: "PBD Exclude Tier Qual 01",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [23, 2],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTier8",
    label: "",
    fieldLabel: "OPS Exclude Tier 8",
    type: "text",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [24, 1],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTierQual8",
    label: "",
    fieldLabel: "PBD Exclude Tier Qual 01",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [24, 2],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTier9",
    label: "",
    fieldLabel: "OPS Exclude Tier 9",
    type: "text",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [25, 1],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTierQual9",
    label: "",
    fieldLabel: "PBD Exclude Tier Qual 01",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [25, 2],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTier10",
    label: "",
    fieldLabel: "OPS Exclude Tier 10",
    type: "text",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [26, 1],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTierQual10",
    label: "",
    fieldLabel: "PBD Exclude Tier Qual 01",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [26, 2],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTier11",
    label: "",
    fieldLabel: "OPS Exclude Tier 11",
    type: "text",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [27, 1],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTierQual11",
    label: "",
    fieldLabel: "PBD Exclude Tier Qual 01",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [27, 2],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTier12",
    label: "",
    fieldLabel: "OPS Exclude Tier 12",
    type: "text",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [28, 1],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTierQual12",
    label: "",
    fieldLabel: "PBD Exclude Tier Qual 01",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [28, 2],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTier13",
    label: "",
    fieldLabel: "OPS Exclude Tier 13",
    type: "text",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [29, 1],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTierQual13",
    label: "",
    fieldLabel: "PBD Exclude Tier Qual 01",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [29, 2],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTier14",
    label: "",
    fieldLabel: "OPS Exclude Tier 14",
    type: "text",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [30, 1],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTierQual14",
    label: "",
    fieldLabel: "PBD Exclude Tier Qual 01",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [30, 2],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTier15",
    label: "",
    fieldLabel: "OPS Exclude Tier 15",
    type: "text",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [31, 1],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTierQual15",
    label: "",
    fieldLabel: "PBD Exclude Tier Qual 01",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [31, 2],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTier16",
    label: "",
    fieldLabel: "OPS Exclude Tier 16",
    type: "text",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [32, 1],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTierQual16",
    label: "",
    fieldLabel: "PBD Exclude Tier Qual 01",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [32, 2],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTier17",
    label: "",
    fieldLabel: "OPS Exclude Tier 17",
    type: "text",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [33, 1],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTierQual17",
    label: "",
    fieldLabel: "PBD Exclude Tier Qual 01",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [33, 2],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTier18",
    label: "",
    fieldLabel: "OPS Exclude Tier 18",
    type: "text",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [34, 1],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTierQual18",
    label: "",
    fieldLabel: "PBD Exclude Tier Qual 01",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [34, 2],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTier19",
    label: "",
    fieldLabel: "OPS Exclude Tier 19",
    type: "text",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [35, 1],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTierQual19",
    label: "",
    fieldLabel: "PBD Exclude Tier Qual 01",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [35, 2],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTier20",
    label: "",
    fieldLabel: "OPS Exclude Tier 20",
    type: "text",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [36, 1],
  },
  {
    section: "Column Headers: 1. Exclude Tiers 2. Tier Qualifier",
    name: "opsExcludeTierQual20",
    label: "",
    fieldLabel: "PBD Exclude Tier Qual 01",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [36, 2],
  },
  {
    section: "Audit Fields",
    name: "addDate",
    label: "Added",
    fieldLabel: "ADD Date",
    type: "text",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Non-Display , Change: Read-only, View: Read-only",
    position: [37, 1],
  },
  {
    section: "Audit Fields",
    name: "chgDate",
    label: "Changed",
    fieldLabel: "CHG Date",
    type: "text",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Non-Display , Change: Read-only, View: Read-only",
    position: [37, 2],
  },
  {
    section: "Audit Fields",
    name: "chgUserName",
    label: "User",
    fieldLabel: "CHG User Name",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Non-Display , Change: Read-only, View: Read-only",
    position: [37, 3],
  },
];
